import { useState, useEffect } from "react";
import { BRAND } from "../../lib/data";

const links = [
  { label: "About", id: "about" },
  { label: "My Story", id: "story" },
  { label: "What I do", id: "services" },
  { label: "Process", id: "process" },
  { label: "Pricing", id: "pricing" },
  { label: "Reviews", id: "reviews" },
  { label: "FAQ", id: "faq" },
];

export const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (id) => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-500 ${
        scrolled ? "backdrop-blur-xl bg-sand/80 border-b border-charcoal/5 py-3" : "py-4"
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-12 flex items-center justify-between gap-3">
        <button
          data-testid="nav-logo"
          onClick={() => go("hero")}
          className="flex items-center gap-2 sm:gap-3 group shrink-0"
        >
          <img src={BRAND.logo} alt={BRAND.name} className="h-9 w-9 sm:h-11 sm:w-11 rounded-full object-cover" />
          <span className="hidden lg:block leading-tight text-left">
            <span className="block font-heading text-xl text-charcoal">{BRAND.name}</span>
            <span className="block text-[10px] uppercase tracking-[0.25em] text-stone">
              Equine Sports Massage
            </span>
          </span>
        </button>

        <nav className="flex items-center gap-1 sm:gap-3 md:gap-6 overflow-x-auto no-scrollbar">
          {links.map((l) => (
            <button
              key={l.id}
              data-testid={`nav-link-${l.id}`}
              onClick={() => go(l.id)}
              className="whitespace-nowrap text-xs sm:text-sm text-stone hover:text-charcoal transition-colors px-1"
            >
              {l.label}
            </button>
          ))}
          <button
            data-testid="nav-book-button"
            onClick={() => go("book")}
            className="whitespace-nowrap shrink-0 bg-clay text-sand rounded-full px-4 sm:px-6 py-2 sm:py-2.5 text-xs sm:text-sm font-medium transition-all duration-300 hover:bg-clay-dark hover:-translate-y-0.5 shadow-sm"
          >
            Book
          </button>
        </nav>
      </div>
    </header>
  );
};
